// helper
import { required, email, onlyNumbers } from '../../../components/FormInputs/helperFunctions'
import InputText from '../../../components/FormInputs/InputText'

export const FORM_FIELDS = [
  {
    name: 'name',
    // className: 'error',
    validation: required,
    component: InputText,
    placeholder: 'Name',
    title: 'Name *'
  },

  {
    name: 'company',
    // className: 'error',
    validation: required,
    component: InputText,
    placeholder: 'Company Name',
    title: 'Company Name *'
  },

  {
    name: 'user',
    validation: required,
    component: InputText,
    placeholder: 'End User',
    title: 'End User'
  },

  {
    name: 'email',
    // className: 'error',
    validation: email,
    component: InputText,
    placeholder: 'Email',
    title: 'Email *'
  },

  {
    name: 'phone',
    // className: 'error',
    validation: onlyNumbers,
    component: InputText,
    placeholder: 'Phone Number',
    title: 'Phone Number *'
  },

  {
    name: 'shipAddress',
    // className: 'error',
    validation: required,
    component: InputText,
    placeholder: 'Ship to Address',
    title: 'Ship to Address *'
  },

  {
    name: 'billAddress',
    // className: 'error',
    validation: required,
    component: InputText,
    placeholder: 'Billing Address',
    title: 'Billing Address *'
  },

  {
    name: 'payment',
    // className: 'error',
    validation: required,
    component: InputText,
    placeholder: 'Mode of Payment',
    title: 'Mode of Payment *'
  },

  {
    name: 'items',
    // className: 'error',
    validation: required,
    component: InputText,
    placeholder: 'Items for RFQ',
    title: 'Items for RFQ *'
  },

]